import Vue from 'vue'

// eslint-disable-next-line import/prefer-default-export
export const events = new Vue({
  name: 'VueConfirmCode',
})
